module.exports = __webpack_public_path__ + "img/finish-step.20c3fca7.png";